export default __webpack_public_path__ + "static/media/431eb86afac3a8928130dfc7d93e1326.png";